import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import * as IPurchases from '../../../../../interfaces/merchants/products/purchases';
import { Me } from '../../../../../interfaces/users';
import PurchaseCheckInput, {
  InputType,
} from '../common/forms/PurchaseCheckInput';
import PurchasePaymentCard from '../common/forms/PurchasePaymentCard';
import PurchaseLabeledContainer from '../common/PurchaseLabeledContainer';

interface Props {
  me: Me;
  selection?: IPurchases.PaymentSelection;
  onSelect: (selection: string) => void;
}

class PaymentMethodsSelector extends React.Component<
  Props & InjectedIntlProps
> {
  constructor(props: Props & InjectedIntlProps) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  private handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const {
      currentTarget: { value },
    } = e;
    this.props.onSelect(value);
  }

  public render() {
    const { me, selection, intl } = this.props;
    return (
      <PurchaseLabeledContainer
        label={intl.formatMessage({
          id: 'purchases.paymentMethodsSelector.pleaseSelect',
        })}
        paddingTop={true}
      >
        {me.creditCard && (
          <PurchasePaymentCard
            tailDigits={me.creditCard.tailDigits}
            value={IPurchases.PaymentSelection.UsedCreditCard}
            checked={selection === IPurchases.PaymentSelection.UsedCreditCard}
            onChange={this.handleChange}
          />
        )}
        <PurchaseCheckInput
          type={InputType.Radio}
          value={IPurchases.PaymentSelection.AnotherCreditCard}
          checked={selection === IPurchases.PaymentSelection.AnotherCreditCard}
          onChange={this.handleChange}
          name="payment-creditcard"
        >
          {intl.formatMessage({
            id: 'purchases.paymentMethodsSelector.addNewCreditCard',
          })}
        </PurchaseCheckInput>
      </PurchaseLabeledContainer>
    );
  }
}

export default injectIntl(PaymentMethodsSelector);
